import randomColor from 'randomcolor';
import {useEffect, useMemo} from 'react';
import {mergeAll} from 'rxjs/operators';
import useSocket from '../../../hooks/use-socket';
import useStore from '../../../hooks/use-store';
import useReportActive from './useReportActive';

const colors = {};

let unsubscribe$ = null;

// Posicao em transito de um device revogado ao vivo (MON-570 removeu do deviceMap antes
// dessa posicao chegar pelo socket) nao pode virar exception -- so nao ha o que traçar.
export const syncTraceOnPosition = (deviceMap, deviceId, map, doBuffer) => {
    const device = deviceMap.get(+deviceId);
    if (!device) return;
    if (device.withTrace) {
        const buffer = doBuffer(device.positionBuffer.toJSON());
        map.updateTrace(deviceId, buffer);
    }
};

const doBuffer =
    (positions) =>
        positions.map(({longitude, latitude, course}) => [
            longitude,
            latitude,
            course,
        ]);

const useMapTrace = (state, dispatch, instance) => {
    const {positions: positionsSocket} = useSocket();
    const {instance: map, deviceMap} = state;
    const {store} = useStore();
    const {devices} = store;
    const reportActive = useReportActive();
    const selectedDevice = devices.selectedDevice;
    const trace = useMemo(() => devices.isSomeDeviceWithTraceEnabled, [devices.isSomeDeviceWithTraceEnabled]);
    const selectedDeviceTrace = devices.selectedDevice && devices.selectedDevice.withTrace;

    // const hasDeviceSelected = (deviceId) => {
    //     if (events.currentDevice || devices.selectedDevice) {
    //         const device = events.currentDevice || devices.selectedDevice;
    //         if (device.deviceId !== deviceId) {
    //             return true;
    //         }
    //     }
    //     return false;
    // };

    useEffect(() => {
        if (map && deviceMap) {
            map.initTraceLayer();

            const c = randomColor({
                luminosity: 'dark',
                count: deviceMap.size,
            });

            for (const deviceId of deviceMap.keys()) {
                colors[deviceId] = c.pop();
            }

            // A camada recem-criada esta vazia: quem continua com a trilha ligada e redesenhado nela.
            for (const [deviceId, device] of deviceMap) {
                if (device.withTrace) {
                    map.addFeatureTrace(deviceId, doBuffer(device.positionBuffer.toJSON()), colors[deviceId]);
                }
            }

            unsubscribe$ = positionsSocket
                .pipe(mergeAll())
                .subscribe(({deviceId}) => {
                    if (reportActive) return;
                    syncTraceOnPosition(deviceMap, deviceId, map, doBuffer);
                });
        }

        return () => {
            unsubscribe$ && unsubscribe$.unsubscribe();
        };
    }, [map, deviceMap, reportActive]);

    // Um relatorio aberto no mapa isola o trajeto: a trilha ao vivo (device.withTrace persiste entre telas) fica
    // escondida enquanto ele estiver aberto e reaparece quando fecha. Esconder a camada, e nao apagar as feicoes,
    // mantem cada trilha na camada para a sincronizacao por posicao continuar desenhando nela. Depende de deviceMap
    // porque o efeito acima recria a camada (e redesenha a trilha ligada) quando ele muda.
    useEffect(() => {
        if (map) {
            map.setTraceLayerVisible(!reportActive);
        }
    }, [reportActive, map, deviceMap]);

    return {
        trace,
        selectedDeviceTrace,
        toggleTrace() {
            if (devices.isSomeDeviceWithTraceEnabled) {
                for (const [deviceId, device] of deviceMap) {
                    device.setTrace(false);
                    map.removeFeaturesTrace(deviceId);
                }
            } else {
                for (const [deviceId, device] of deviceMap) {
                    if (device.withTrace) continue;
                    const buffer = doBuffer(device.positionBuffer.toJSON());
                    map.addFeatureTrace(deviceId, buffer, colors[deviceId]);
                    device.setTrace(true);
                }
            }
        },
        toggleSelectedDeviceTrace() {
            if (selectedDevice) {
                if (!selectedDeviceTrace) {
                    const buffer = doBuffer(selectedDevice.positionBuffer.toJSON());
                    map.addFeatureTrace(selectedDevice.id, buffer, colors[selectedDevice.id]);
                    selectedDevice.setTrace(true);
                } else {
                    selectedDevice.setTrace(false);
                    map.removeFeaturesTrace(selectedDevice.id);
                }
            }
        },
        setTrace() {
            // should remove it!
        },
        toogleTrace() {
            // should be removed!
        },
    };
};

export default useMapTrace;
